<template>
  <div class="tab">
    <main class="page_container">
      <el-skeleton v-if="loading" animated :rows="4" />
      <el-row v-else-if="!hasEvents" type="flex" justify="center" align="middle" class="camera-sharing-history__empty-row">
        <el-col :span="24">
          <el-empty
            :image-size="120"
            description="Нет доступных событий"
            class="camera-sharing-history__empty-row"
          />
        </el-col>
      </el-row>
      <template v-else>
        <el-table
          v-loading="loading"
          :data="events"
        >
          <el-table-column
            prop="initiator_login"
            label="Логин инициатора"
            min-width="160"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="datetime"
            label="Дата и время"
            min-width="170"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="action"
            label="Действие"
            min-width="140"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="target_login"
            label="Кому предоставлен доступ"
            min-width="190"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="rights"
            label="Права"
            min-width="200"
            header-align="center"
            align="center"
          />
        </el-table>
        <div class="camera-sharing-history__pagination">
          <el-pagination
            :total="total"
            :page-size="count"
            :current-page="page"
            hide-on-single-page
            @current-change="changePage"
            layout="prev, pager, next"
          />
        </div>
      </template>
    </main>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import list from "@/core/mixins/list";

const PER_PAGE = 12;
const STATUS_HISTORY_LABELS = {
  1: "Выдача прав",
  2: "Редактирование прав",
  3: "Удаление прав",
};
const SHARE_SOURCE_LABELS = {
  0: "ЛК или Админка",
  1: "Группа камер",
};

export default {
  name: "CameraSharingHistory",
  mixins: [list],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      total: 0,
      count: PER_PAGE,
      rows: [],
      needsRefresh: false,
    };
  },
  computed: {
    page() {
      return this.currentPage;
    },
    hasEvents() {
      return this.total > 0 && this.rows.length > 0;
    },
    events() {
      return this.rows.map((row) => {
        const datetime = row.sh_dt || "-";

        const initiatorLogin = row.editor_login || "-";
        const targetLogin = row.recipient_login || "-";
        const statusType = row.status_type ?? row.status_history ?? null;
        let action = STATUS_HISTORY_LABELS[statusType] || "";

        const hasAnyAccess =
          row.is_access_share ||
          row.is_access_archive ||
          row.is_access_settings ||
          row.is_access_sound ||
          row.is_access_rename ||
          row.is_access_ptz ||
          row.is_share_admin;

        if (!action) {
          action = hasAnyAccess ? STATUS_HISTORY_LABELS[2] : STATUS_HISTORY_LABELS[3];
        }

        const isGrantOrEdit = statusType === 1 || statusType === 2 || (!statusType && hasAnyAccess);
        let rights = "-";
        if (isGrantOrEdit) {
          const rightsList = [];
          if (row.is_share_admin) rightsList.push("Передача доступа");
          if (row.is_access_archive) rightsList.push("Архив");
          if (row.is_access_settings) rightsList.push("Настройки");
          if (row.is_access_sound) rightsList.push("Звук");
          if (row.is_access_rename) rightsList.push("Переименование");
          if (row.is_access_ptz) rightsList.push("PTZ");
          rights = rightsList.length ? rightsList.join(", ") : "-";
        }

        return {
          id: `${row.editor_login || ""}-${row.sh_dt || ""}-${row.grantee_login || row.recipient_login || ""}`,
          initiator_login: initiatorLogin ,
          datetime,
          action,
          target_login: targetLogin,
          rights,
        };
      });
    },
  },
  created() {
    this.loadData();
    this.$root.$on("camera-sharing-history-refresh", this.setNeedsRefresh);
    this.$root.$on("camera-sharing-history-tab-activated", this.onTabActivated);
  },
  activated() {
    this.checkAndRefresh();
  },
  mounted() {
    this.checkAndRefresh();
  },
  beforeDestroy() {
    this.$root.$off("camera-sharing-history-refresh", this.setNeedsRefresh);
    this.$root.$off("camera-sharing-history-tab-activated", this.onTabActivated);
  },
  methods: {
    ...mapActions("cameras", ["GET_CAMERA_SHARES_HISTORY"]),
    changePage(page) {
      this.currentPage = page;
      this.loadData();
    },
    setNeedsRefresh() {
      this.needsRefresh = true;
    },
    onTabActivated() {
      this.checkAndRefresh();
    },
    checkAndRefresh() {
      if (this.needsRefresh) {
        this.needsRefresh = false;
        this.loadData();
      }
    },
    loadData() {
      this.loading = true;
      const page = this.page || 1;
      const count = this.count || PER_PAGE;
      
      return this.GET_CAMERA_SHARES_HISTORY({
        id: this.id,
        page,
        count,
      })
        .then((result) => {
          this.rows = result.items;
          this.total = result.total;
        })
        .catch(() => {
          this.rows = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="postcss">
  .camera-sharing-history__empty-row {
    font-size: 19px;
    font-weight: 700;
    min-height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .camera-sharing-history__pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>
